import type { Me } from "../types";

// App-level Omni Hub admin (Settings + repository management). Distinct from the
// DevHub CMS `role` — resolved server-side from the admin Okta group (GET /api/me).
//
// This lives in its own module, apart from the useMe hook it used to sit beside,
// so that code which only needs to ASK THE QUESTION doesn't have to load React and
// the auth client to do it. devhub/lib/roles.ts is the case that matters: it is a
// pure permission table, and importing it used to pull in useMe → auth, which
// reads `window.location` at module load. That made the CMS's permission
// predicates unreachable from a unit test — recorded as a known limitation on
// ENG-53859 — even though every one of them is a pure function of `me`.
//
// Re-exported from useMe.ts, so nothing that already imports it from there had to
// change.
export function isAppAdmin(me: Me | null): boolean {
  return me?.admin === true;
}
